<div class="attachment-move-dialog">
  <div class="attachment-move-dialog__header">
    <div class="left">
      <h3>Mutual Connections</h3>
    </div>
    <div class="right">
      <button mat-icon-button (click)="closeDialog()" class="p-0">
        <mat-icon style="font-size: 19px; height: 15px; width: 19px;color: #25508E;">close</mat-icon>
      </button>
    </div>
  </div>
  <div class="attachment-move-dialog__content">
    @if(mutualUserlist === null){
      <div class="h-full w-full loader-option overflow-hidden">
        <div class="search-box-container w-full">
          <div class="loader-container grid grid-cols-1 p-0">
            @for (item of ['', '', '']; track item) {
              <div class="w-full h-[70px]">
                <div class="w-full h-full" id="{{ item.id }}">
                  <div class="ph-item w-full content__loader h-full" style="padding: 0px; margin: 0px; border: none">
                    <div class="ph-col-12 h-full" style="padding: 0px !important; margin: 0px">
                      <div class="ph-row h-full">
                        <div class="ph-col-12 h-[90%]"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
      }@else{
      @if( mutualUserlist.length === 0 ){
        <div class="zero-state-container">
          <img src="../../../../../assets/images/user_logo.svg" alt="User Logo" class="user-logo">
          <p class="mutual-text">No <span>Mutual Connections</span> to show</p>
        </div>
      }
      @else{
      <div class="suggestions-container">
        @for (user of mutualUserlist; track user) {
          <div class="suggestion-item">
            <app-user-avatar [name]="user" avatarClass="profile-image" size="50" ></app-user-avatar>
            <div class="user-info">
              <h5 class="user-name">{{ user.name}}</h5>
              <p class="user-location">{{ user.relationship_name }}</p>
            </div>
          </div>
        }
      </div>
    }
  }

</div>
</div>